import React from 'react'
import { ActivityHistoryTypeEnum } from '../activityHistoryTypes'
import { Flex, Text } from 'front-end/src/components'
import IconBadge from '../../../components/common/icon/IconBadge'
import ActivityNameInfo from './ActivityNameInfo'
import { linkBuilder } from 'shared/linkBuilder'

interface ActivityHistoryEventNameProps {
  title?: string
  name?: string
  hasCertification: boolean
  id: number
  isArchived?: boolean
}

const ActivityHistoryEventName = ({
  title,
  hasCertification,
  name = '',
  id,
  isArchived
}: ActivityHistoryEventNameProps) => {
  return (
    <ActivityNameInfo
      typename={ActivityHistoryTypeEnum.UserEventModel}
      title={title}
      linkUrl={linkBuilder.eventDetail(id)}
      isArchived={isArchived}
    >
      {hasCertification && (
        <Flex>
          <IconBadge mr="4px" />
          <Text lineHeight="21px" noOfLines={2}>
            {name}
          </Text>
        </Flex>
      )}
    </ActivityNameInfo>
  )
}

export default ActivityHistoryEventName
